module.exports = __webpack_public_path__ + "img/0Q3A5798_L_Foamcore.1ac4ac8c.jpg";